import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, RadioControlValueAccessor } from '@angular/forms';

import { IconTypeEnum } from '~/component/icon/enums/icon-type.enum';

@Component({
  selector: 'app-form-radio-button',
  templateUrl: './radio-button.component.html',
  styleUrls: ['./radio-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormRadioButtonComponent),
      multi: true,
    },
  ],
})
export class FormRadioButtonComponent extends RadioControlValueAccessor {
  @Input() public disabled = false;
  @Input() public error = false;
  @Input() public htmlValue: string;
  @Input() public label?: string;

  public get iconName(): IconTypeEnum {
    return this.value === this.htmlValue
      ? IconTypeEnum.RadioButton
      : IconTypeEnum.CheckBoxBlankCircle;
  }

  public fireUncheck(_value: string): void {
    this.value = '';
  }

  public writeValue(value: string): void {
    this.value = value;
  }
}
